import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { VngButtonComponent } from "@vengreso/angular-components";
import { NotificationLinkContent, NotificationTemplate } from "src/app/core/models/notification.model";
import { NavigationService } from "src/app/core/core-services/services/navigation.service";
import { NotificationTemplateRenderer } from "../notification-template-renderer";

/** Renders `{kind: "link", content: {title, body?, url, label?}}` — text plus a CTA link opened via `NavigationService`. */
@Component({
  selector: "app-notification-link-renderer",
  standalone: true,
  imports: [CommonModule, VngButtonComponent],
  templateUrl: "./notification-link-renderer.component.html",
  styleUrls: ["../notification-templates.scss"],
})
export class NotificationLinkRendererComponent implements NotificationTemplateRenderer {
  @Input() template!: NotificationTemplate;
  @Output() respond = new EventEmitter<Record<string, unknown>>();

  constructor(private readonly navigationService: NavigationService) {}

  private get content(): NotificationLinkContent {
    return this.template?.content as unknown as NotificationLinkContent;
  }

  get title(): string {
    return this.content?.title ?? "";
  }

  get body(): string | undefined {
    return this.content?.body;
  }

  get label(): string {
    return this.content?.label || "View";
  }

  open(): void {
    if (this.content?.url) {
      this.navigationService.navigateToUrl(this.content.url);
    }
  }
}
